<template>
  <div id="point" class="full_layout point market">

    <!-- <build v-if="!isNull"/> -->
    <div class="breadcrumbANDsort">
      <div class="breadcrumb">
        <router-link :to="{path:'/'}">首页</router-link>
        <span>积分商城</span>
      </div>
      <div class="pointSort">
        <span class="" :class="userInfo!=null?'pointInfo':''"><span v-if="userInfo!=null">我当前积分: {{userInfo.PointsAll}}</span></span>
        <div>
          积分 
          <el-select v-model="pointSort" placeholder="全部" class="pointSelect" @change="checkPointChange()">
          <el-option v-for="(item,index) in pointOptions" :key="index" :value="item.value">
          </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="space_between" >
      <div class="productsClassBox">
        <div class="productsClass">
          <div class="productsClassTitle">筛选</div>
          <div class="productScreenBox">
            <el-collapse v-model="openeds" class="productCollapse">
              <el-collapse-item :name="1">
                <template slot="title">
                  类别
                </template>
                <div class="productCollapseList">
                  <el-checkbox-group v-model="check" class="productScreenCheckbox" @change='checkboxChange()'>
                    <div v-for="(item,i) in checkList" :key="i">
                      <el-checkbox :label="item._id" >{{item.ChName}}</el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
      <div class="productsListBox" v-if="!isNull">
        <ul class="products" v-if="list!=null">
          <li v-for='(item,index) in list' :key='index' :class="[item.QuantitySold<=0?'sold':'']">
            <div class="outOfStock" v-if="item.QuantitySold<=0">缺货</div>
            <router-link :to="{path:'/point/item/'+item._id}">
              <div class="imgBox">
                <img :src="item.TitImg+'?imageView2/2/w/238'">
              </div>
              <div class="line_txt3 productsText">
                {{item.Title}}
              </div>
              <div class="pointsPrice">{{item.PointsScore}} 积分<span class="text_red" v-if="item.Price>0"> + ￥{{item.Price.toLocaleString()}}</span></div>
            </router-link>
          </li>
        </ul>
        <pagination :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!isNull" />
      </div>
      <div class="productsListBox" v-if="isNull">
        <nonull type='item' text="没有相关商品" />
      </div>
    </div>
  </div>
</template>
<script>
import { CookiesCategory, getInfo } from "@/api/public";
import Build from '@/components/build'
import Pagination from '@/components/pagination'
import Nonull from '@/components/nonull'
export default {
  name: 'point',
  components: { Build,Pagination, Nonull },
  data() {
    return {
      isNull: false,
      userInfo: getInfo(),
      loading: false,
      openeds: [1],
      checkList:[],
      check:[],
      pointSort:'全部',
      pointOptions:this.$enumInfo.pointOptions,
      list: null,
      ps: 24, //pagesize
      pi: 1, //pageindex
      TotalCount: 0,
      MinPoints:'',
      MaxPoints:''
    }
  },
  mounted() {},
   watch: {
    '$route': 'getPath'
  },
  created() {
    this.getPath()
    this.getCommodityList()
  },
  methods: {
    getPath() {
      this.userInfo = getInfo()
      this.getCategoryList()
    },
    checkboxChange(){
      this.getCommodityList()
    },
    checkPointChange(){
      var that=this
      if(that.pointSort==='全部'){
        that.MinPoints=''
        that.MaxPoints=''
      }else{
        try{
        var pointPrice=that.pointSort.split('-')
        that.MinPoints=pointPrice[0]
        that.MaxPoints=pointPrice[1]
        }catch(e){

        that.MinPoints=''
        that.MaxPoints=''
        }
        
      }
      this.getCommodityList()
    },
    getCategoryList(){
      let that = this;
      that.$get(that.$interface.GetOnlyPointsCategories, '').then(res => {
        if(res.Result!=0){
          that.checkList=res.Data
        }
        console.log(res)
      })
    }, 
    getCommodityList(){
      let that = this;
      var fid="";
      console.log(that.check)
      if(that.check.length>0){
        fid=that.check.join(',')
      }
      var data={
        FirstCategoryId:fid,
        Title:'',
        MinPoints:that.MinPoints,
        MaxPoints:that.MaxPoints,
        PageIndex:that.pi,
        PageSize:that.ps
      }
      that.$get(that.$interface.GetPointsCommodities,data).then(res => {
        if(res.Result!=0){

          that.list=res.Data
          if(res.Count>0){
          that.isNull=false
          }else{
            that.isNull=true
          }
        }else{
          that.isNull=true
        }
        console.log(res)
      })
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.getCommodityList()

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.getCommodityList()
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/market.css";
.pointSelect{
  width: 120px;
  height: 30px;
}
/deep/ .pointSelect .el-input__inner{
  height: 30px;
}
/deep/ .pointSelect .el-input__icon{
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/point/index.vue